import { getListOfWhatsAppAccounts } from "../types/whatsapp_account_list_types";

export const getListOfWhatsAppAccountsRequest = (payload, cb) => ({
  type: getListOfWhatsAppAccounts.GET_LIST_OF_WHATSAPP_ACCOUNTS_REQUEST,
  payload,
  cb,
});
export const getListOfWhatsAppAccountsSuccess = (payload) => ({
  type: getListOfWhatsAppAccounts.GET_LIST_OF_WHATSAPP_ACCOUNTS_SUCCESS,
  payload,
});
export const getListOfWhatsAppAccountsError = (payload) => ({
  type: getListOfWhatsAppAccounts.GET_LIST_OF_WHATSAPP_ACCOUNTS_ERROR,
  payload,
});


export const getCountOfWhatsAppAccounts = (payload, cb) => ({
  type: getListOfWhatsAppAccounts.GET_COUNT_OF_WHATSAPP_ACCOUNTS_REQUEST,
  payload,
  cb,
});

export const getCountOfWhatsAppAccountsSuccess = (payload, cb) => ({
  type: getListOfWhatsAppAccounts.GET_COUNT_OF_WHATSAPP_ACCOUNTS_SUCCESS,
  payload,
  cb,
});

export const getCountOfWhatsAppAccountsError = (payload, cb) => ({
  type: getListOfWhatsAppAccounts.GET_COUNT_OF_WHATSAPP_ACCOUNTS_ERROR,
  payload,
  cb,
});

